// extracted by mini-css-extract-plugin
export default {"title":"AboutDescription_title__ieQ3K","serviceDescription":"AboutDescription_serviceDescription__SF6ew"};